import React from "react";
import "./industry-landing.scss";
import {
  TypeGlobalEnterprisesFPage,
} from "../utils/queries/global_enterprises";
import {
  PageHeaderCustomV2WhiteWide,
  PageHeaderStandard,
} from "../components/page-header/page-header";
import Helmet from "react-helmet";
import { PageTitle } from "../components/title/title";
import AmazeeIoMetadata from "../components/metadata";
import RichTextRender from "../utils/rich-text";
import AmazeePage from "../components/layout";
import usePreviewData from "../utils/usePreviewData";
import Calender from "../components/Calender";

const GlobalEnterprisesPage = ({ pageContext, location }: any) => {
  const result = usePreviewData(
    pageContext.data,
    "PrismicGlobalEnterprises",
    true
  ) as TypeGlobalEnterprisesFPage;
  const showPage = true;

  return showPage ? (
    <AmazeePage
      location={location}
      id="global-enterprises"
      classSet="industry-landing"
    >
      <div>
        <Helmet>
          <link rel="stylesheet" href="/css/carousel-single.min.css" />
          <link rel="stylesheet" href="/css/carousel-multi.min.css" />
          {result.canonical_url && (
            <link rel="canonical" href={result.canonical_url} />
          )}
        </Helmet>
        <PageTitle title={RichTextRender(result.title.text)} />
        <AmazeeIoMetadata
          title={RichTextRender(result.title.text)}
          page_meta_description={result.page_meta_description}
          page_meta_thumbnail={result.page_meta_thumbnail}
          location={location}
        />

        <PageHeaderStandard
          component={PageHeaderCustomV2WhiteWide}
          header={RichTextRender(result.title)}
          image={result.hero_image}
          subheader={result.subtitle}
          withSiteName={false}
          hasSectionDivider={false}
        />

        <section id="services">
          <div className="container">
            <div className="row">
              {result.services.map((service, index) => (
                <div key={index} className="col-12 col-lg-4 service">
                  <img
                    src={service.service_image.url}
                    alt={service.service_image.alt}
                  />
                  <div className="service-title">{service.service_title}</div>
                  <div className="description">
                    {service.service_description}
                  </div>
                  <div className="border-divider"></div>
                  <div className="description">{service.foot_notes}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="protect-your-web-application" className="quote">
          <div className="container">
            <div className="row flex justify-center items-center">
              <div className="col-10 text-left">
                <div className="description">
                  {RichTextRender(result.section_text1)}
                </div>
              </div>
              <div className="col-10 flex justify-start img-wrap">
                <img src={result.image1.url} alt={result.image1.alt} />
                <div className="quote-text">
                  <span className="name">{result.section_title1}</span>
                  <span className="company">{result.section_subtitle1}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" className="services-lower">
          <div className="container">
            <div className="row">
              {result.services_lower.map((service_lower, index) => (
                <div key={index} className="col-12 col-lg-4 service">
                  <img
                    src={service_lower.service_image_lower.url}
                    alt={service_lower.service_image_lower.alt}
                  />
                  <div className="service-title">
                    {service_lower.service_title_lower}
                  </div>
                  <div className="description">
                    {service_lower.service_description_lower}
                  </div>
                  <div className="border-divider"></div>
                  <div className="description">{service_lower.foot_notes}</div>
                </div>
              ))}
            </div>
          </div>
        </section> 

      {RichTextRender(result.title.text) === "amazee.io for SaaS" && (

      <section className="get-started py-5">
        <div className="max-w-screen-amazee-lg xl:max-w-screen-amazee-xl mx-auto grid md:grid-cols-2 gap-x-8 items-center justify-center md:justify-items-start">
          <img className="w-3/4"
            src="https://amazeeio.cdn.prismic.io/amazeeio/aXt6LQIvOtkhCFGG_ProvusGov-Banner-Teaser-1-.svg"
            alt="Check out our work for Promet Source"
          />
          <div className="px-6 md:px-0">
            <h2 className="font-semibold text-2xl md:text-3.5xl text-white mb-4">
              Check out our work for Promet Source
            </h2>
            <p className="text-white font-normal text-lg">amazee.io collaborated with Promet Source to provide secure hosting for their Provus<span className="text-xs align-top">®</span>Gov demo environments.</p>
            <ul className="lg:my-10 my-3">
              {[
                'Instant demos – Provus<span class="text-xs align-top">®</span>Gov instances running in minutes',
                "Enterprise-grade security and compliance",
                "Data sovereignty by design",
                "Secure-by-default infrastructure",
              ].map((text, index) => (
                <li
                  key={index}
                  className="text-white lg:text-xl mb-3 flex gap-x-1 items-center"
                >
                  <div className="tick mr-2 rounded-full p-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="#00B6ED"
                        d="M8.29,14.64c-0.38,0-0.76-0.15-1.06-0.43l-2.87-2.82c-0.59-0.58-0.6-1.53-0.01-2.12 c0.58-0.59,1.53-0.6,2.12-0.02l1.81,1.78l5.23-5.23c0.59-0.59,1.54-0.59,2.12,0s0.59,1.54,0,2.12L9.35,14.2 C9.06,14.5,8.67,14.64,8.29,14.64z"
                      />
                    </svg>
                  </div>
                  <p className="mb-0" dangerouslySetInnerHTML={{ __html: text }} />
                </li>
              ))}
            </ul>
            
              <a href="https://amazee.io/industry/saas/ai-drupal-government-provusgov"
              className="text-center md:text-left"
            >
              <div className="btn-boldish amazeeio-button rounded-full px-4 py-2 btn-boldish amazeei-button inverted inline-block width-auto mt-4">
                Learn More
              </div>
            </a>
          </div>
        </div>
      </section>
      )}


        <Calender
          className=""
          calender_body={result.calender_body}
          calender_embed={result.calender_embed}
          calender_heading={result.calender_heading}
          calender_subheading={result.calender_subheading}
          calender_title={result.calender_title}
          image={result.calender_image}
        />

      </div>
    </AmazeePage>
  ) : (
    <div>You can’t access this secret page.</div>
  );
};

export default GlobalEnterprisesPage;
